import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { technologyTabs } from '../mock';

const TechnologyTabs = () => {
  const [active, setActive] = useState(technologyTabs[0].key);
  const current = technologyTabs.find((t) => t.key === active);

  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0d274d] max-w-4xl leading-tight">
          Market-defining technologies driving the future of AI
        </h2>

        <div className="mt-10 flex flex-wrap gap-2 border-b border-gray-200">
          {technologyTabs.map((t) => (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              className={`px-4 py-3 text-sm font-medium transition-colors border-b-2 -mb-px ${
                active === t.key
                  ? 'text-[#0d274d] border-[#00bceb]'
                  : 'text-gray-600 border-transparent hover:text-[#0d274d]'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div key={current.key} className="mt-10 grid lg:grid-cols-2 gap-10 items-center fade-up">
          <div className="order-2 lg:order-1">
            <h3 className="text-2xl md:text-3xl font-semibold text-[#0d274d] mb-5 leading-snug">{current.title}</h3>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">{current.description}</p>
            <a href="#" className="inline-flex items-center gap-2 text-[#0d274d] font-semibold border-b-2 border-[#00bceb] pb-1 hover:text-[#00bceb]">
              {current.cta}
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
          <div className="order-1 lg:order-2 overflow-hidden rounded">
            <img src={current.image} alt={current.title} className="w-full h-auto object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologyTabs;
